 <!--<printheaderview [hasimage]="1"></printheaderview>-->

  <div class="row border2px borderrad2px margin-left-0px margin-right-0px" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
    <div class="col-print-12 padding-left-0px padding-top-25px padding-bottom-25px">
      <div class="card height280">
        <div class="card-header padding-left-0px padding-right-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px font-weight-normal">

          <!--<div class="row">
    <div class="col-print-12 text-align-center">
      <label class="margin-bottom-0px margin-top-0px font-familyhead border-bot-1px">Patient Case Record</label>
    </div>

  </div>-->
          <!--<div class="row">
    <div class="col-print-10 text-align-center">
      <label class="margin-bottom-0px margin-top-0px font-familyhead"></label>
    </div>
    <div class="col-print-2 padding-top-0px padding-bottom-0px">
      <qrcode class="padding-top-0px padding-bottom-0px qr-style" [qrdata]="l.FormattedCode" [size]="90" [level]="'M'"></qrcode>
    </div>
  </div>-->
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <img class="img85px" src="gg-logo-2.jpg">
              </div>

            </div>
          </div>

          <div class="col-print-12 border-bot-1px bordertop">
            <div class="row margin-left-0px padding-top-20px">
              <div class="col-print-3">
                <div class="row margin-left-20p padding-top-5px">
                  <div class="col-print-12">
                    <img class="user-image-circle-65px img100px" [src]='l.PatientImageFile' onError="this.src='dummy.jpg';">
                  </div>

                </div>

              </div>

              <div class="col-print-1">
                <div class="row margin-left-0px">
                  <div class="col-print-12">
                  </div>
                </div>

              </div>

              <div class="col-print-6">
                <div class="row margin-left-0px">
                  <!--<div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal">NAME:</label>
      </div>-->
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.DisplayName}}</label>
                  </div>
                </div>

                <!--<div class="row margin-left-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>-->

                <div class="row margin-left-0px">
                  <!--<div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal">DOB:</label>
      </div>-->
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">DOB: {{l.DateOfBirth | date:'dd-MMM-yyyy'}}</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <!--<div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal">DOB:</label>
      </div>-->
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Gender}}</label>
                  </div>
                </div>
                <!--<div class="row margin-left-0px">
      <div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal">PATIENT ID:</label>
      </div>
      <div class="col-print-7">
        <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.FormattedCode}}</label>
      </div>
    </div>-->
                <!--<div class="row margin-left-0px">
      <div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal">BLOOD GROUP:</label>
      </div>
      <div class="col-print-7">
        <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.BloodGroup}}</label>
      </div>
    </div>-->
                <div class="row margin-left-0px">
                  <!--<div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-phone"></i> :</label>
      </div>-->
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"><i class="fas fa-phone"></i> : {{l.Telephone1}}</label>
                  </div>
                </div>

              </div>

              <div class="col-print-2 padding-top-10px">
                <qrcode class="padding-top-0px qr-style9 padding-bottom-0px" [qrdata]="FormattedCode" [size]="65" [level]="'M'"></qrcode>
              </div>

            </div>

            <div class="row margin-left-0px">
              <div class="col-print-5">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-7">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <!--<div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-7">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->

          <div class="col-print-12">
            <div class="row">
              <div class="col-print-12 text-align-center">
                <label class="margin-bottom-0px margin-top-0px font-familyhead">{{l.FormattedCode}}</label>
              </div>
            </div>
          </div>

          <!--<div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-5">
        <div class="row margin-left-0px">
          <div class="col-print-12">
            <label class="margin-bottom-0px font-familysubhead font-weight-normal">ADDRESS</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <div class="col-print-1"></div>
          <div class="col-print-11">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.AddressLine1}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.City}}</label>
            </div>
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.State}} {{l.ZipCode}}</label>
            </div>

          </div>
        </div>


      </div>
      <div class="col-print-3">

      </div>
      <div class="col-print-4">
        <div class="row margin-left-0px">
          <div class="col-print-12">
            <label class="margin-bottom-0px font-familysubhead font-weight-normal">CONTACT DETAILS</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <div class="col-print-2">
            <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-phone"></i> :</label>
          </div>
          <div class="col-print-9">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Telephone1}}</label>
          </div>
        </div>
        <div class="row margin-left-0px">
          <div class="col-print-2">
            <label class="margin-bottom-0px font-family font-weight-normal"><i class="fas fa-envelope"></i> :</label>
          </div>
          <div class="col-print-9">
            <label class="margin-bottom-0px font-family float-left font-weight-normal">{{l.Email}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-print-12">
    <div class="row margin-left-0px">
      <div class="col-print-5">
        <label class="margin-bottom-0px font-family font-weight-normal"></label>
      </div>
      <div class="col-print-7">
        <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
      </div>
    </div>
  </div>-->


        </div>
      </div>
    </div>

  </div>

